import React, { ChangeEvent } from "react";
import { Door } from "../../1/types";

interface LockType {
  id: number;
  type_code: string;
  name: string;
  icon_path: string | null;
  display_order: number;
  is_active: number | boolean;
}

interface DoorRowProps {
  door: Door;
  index: number;
  disabled?: boolean;
  backendUrl: string;
  findDoor: (name: string) => Door | undefined;
  handleRemoveDoorx: (id: number) => void;
  handleInputChangeAmont: (index: number, value: number, field: string, step: number) => void;
  handleDoorChange: (index: number, field: keyof Door, value: string | number) => void;
  handleInputChange: (
    index: number,
    field: keyof Door,
    value: string | number,
    numb: number,
    step: number,
    name: string,
    innen: number,
    auben: number
  ) => void;
  lockTypes: LockType[];
}

const DoorRow: React.FC<DoorRowProps> = ({
  door,
  index,
  disabled,
  backendUrl,
  findDoor,
  handleRemoveDoorx,
  handleInputChangeAmont,
  handleDoorChange,
  handleInputChange,
  lockTypes,
}) => {
  const found = findDoor(door.doorName);
  if (!found) return null;
  return (
    <div
      key={door.doorName}
      className="door-row"
      style={{
        display: "flex",
        flexDirection: "row",
        borderBottom: "1px solid #ddd",
        backgroundColor: "#F3F3F3",
        margin: "0.25% 0.5%",
        alignItems: "center",
        padding: "4px 6px",
      }}
    >
      {/* Mobile X button - shows at top on mobile */}
      {disabled || (
            <img
              src={`${backendUrl}/img/XRed.svg`}
              alt="X"
              className="door-delete-btn"
              style={{
                width: "14px",
                height: "14px",
                cursor: "pointer",
                marginLeft: "1%",
              }}
              onClick={() => handleRemoveDoorx(Number(found?.id))}
            />
      )}

      {/* First row container for mobile: name + amount + image + type */}
      <div className="door-main-row" style={{ display: "flex", alignItems: "center", gap: "12px", flex: 1 }}>
        {/* Door name */}
        <div className="col-name door-col-name" style={{ color: "black" }}>
          {door.doorName}
        </div>

        {/* Amount controls */}
        <div className="col-amount door-col-amount" style={{ color: "black" }}>
          <div className="door-amount-controls">
            {disabled || (
              <div className="inputValueChangerForm">
                <div
                  onClick={() =>
                    handleInputChangeAmont(
                      index,
                      Number(found.lockAmount),
                      "lockAmount",
                      -1
                    )
                  }
                >
                  <img
                    src={`${backendUrl}/img/configurator/minus.svg`}
                    alt="minus"
                    style={{ width: "12px" }}
                  />
                </div>
              </div>
            )}
            <input
              type="number"
              readOnly
              disabled={disabled}
              value={found.lockAmount}
              style={{
                width: "30px",
                border: "none",
                backgroundColor: "#F3F3F3",
                borderBottom: "#B1B1C5 solid 1px",
                textAlign: "center",
              }}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                handleDoorChange(index, "lockAmount", parseInt(e.target.value, 10))
              }
            />
            {disabled || (
              <div className="inputValueChangerForm">
                <div
                  onClick={() =>
                    handleInputChangeAmont(
                      index,
                      Number(found.lockAmount),
                      "lockAmount",
                      1
                    )
                  }
                >
                  <img
                    src={`${backendUrl}/img/configurator/plus.svg`}
                    alt="plus"
                    style={{ width: "12px" }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Lock image and type */}
        <div className="col-type door-col-meta" style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "nowrap" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <img
              src={`${backendUrl}${lockTypes.find(lt => lt.type_code === found.lockType)?.icon_path || `/img/Types/${encodeURIComponent(found.lockType)}.png`}`}
              alt={found.lockType}
              style={{ width: "28px", height: "auto" }}
            />
            <span style={{ fontSize: "0.85rem" }}>
              {found.lockType === "Briefkastenzylinder" ? "BKZ" : found.lockType}
            </span>
          </div>
          
          {/* Dimensions inline with type */}
          <div className="door-dimensions-group" style={{ display: "flex", alignItems: "center", flexWrap: "nowrap", gap: "4px", fontSize: "0.8rem" }}>
            <span>innen:</span>
            {disabled || (
              <div
                className="inputValueChangerForm"
                style={{ marginInlineStart: "2px", textAlign: "right" }}
              >
                <div
                  onClick={() =>
                    handleInputChange(
                      index,
                      "lockInside",
                      "",
                      Number(found.lockInside),
                      -5,
                      String(found.lockType),
                      Number(found.lockInside),
                      Number(found.lockOutside)
                    )
                  }
                >
                  <img
                    src={`${backendUrl}/img/configurator/minus.svg`}
                    alt="minus"
                    style={{ width: "10px" }}
                  />
                </div>
              </div>
            )}
            <input
              type="number"
              readOnly
              value={found.lockInside}
              style={{
                width: "35px",
                border: "none",
                backgroundColor: "#F3F3F3",
                borderBottom: "#B1B1C5 solid 1px",
                textAlign: "center",
                margin: "0 2px",
                fontSize: "0.8rem",
              }}
              disabled={
                disabled ||
                found.lockType === "VHS" ||
                found.lockType === "HPZ" ||
                found.lockType === "Briefkastenzylinder"
                  ? true
                  : false
              }
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                handleDoorChange(index, "lockInside", parseInt(e.target.value, 10))
              }
            />
            {disabled || (
              <div className="inputValueChangerForm" style={{ marginInlineEnd: "2px" }}>
                <div
                  onClick={() =>
                    handleInputChange(
                      index,
                      "lockInside",
                      "",
                      Number(found.lockInside),
                      5,
                      String(found.lockType),
                      Number(found.lockInside),
                      Number(found.lockOutside)
                    )
                  }
                >
                  <img
                    src={`${backendUrl}/img/configurator/plus.svg`}
                    alt="plus"
                    style={{ width: "10px" }}
                  />
                </div>
              </div>
            )}
            <span>außen:</span>
            {disabled || (
              <div
                className="inputValueChangerForm"
                style={{ marginInlineStart: "2px", textAlign: "right" }}
              >
                <div
                  onClick={() =>
                    handleInputChange(
                      index,
                      "lockOutside",
                      "",
                      Number(found.lockOutside),
                      -5,
                      String(found.lockType),
                      Number(found.lockInside),
                      Number(found.lockOutside)
                    )
                  }
                >
                  <img
                    src={`${backendUrl}/img/configurator/minus.svg`}
                    alt="minus"
                    style={{ width: "10px" }}
                  />
                </div>
              </div>
            )}
            <input
              type="number"
              readOnly
              value={found.lockOutside}
              style={{
                width: "35px",
                border: "none",
                backgroundColor: "#F3F3F3",
                borderBottom: "#B1B1C5 solid 1px",
                textAlign: "center",
                margin: "0 2px",
                fontSize: "0.8rem",
              }}
              disabled={
                disabled ||
                found.lockType === "VHS" ||
                found.lockType === "Briefkastenzylinder"
                  ? true
                  : false
              }
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                handleDoorChange(index, "lockOutside", parseInt(e.target.value, 10))
              }
            />
            {disabled || (
              <div className="inputValueChangerForm">
                <div
                  onClick={() =>
                    handleInputChange(
                      index,
                      "lockOutside",
                      "",
                      Number(found.lockOutside),
                      5,
                      String(found.lockType),
                      Number(found.lockInside),
                      Number(found.lockOutside)
                    )
                  }
                >
                  <img
                    src={`${backendUrl}/img/configurator/plus.svg`}
                    alt="plus"
                    style={{ width: "10px" }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        
      </div>

      <div className="door-price-row" style={{ display: "contents" }}>
        <div
          className="door-col-net"
          style={{
            fontSize: "12px",
            color: "black",
            padding: "4px 2px",
            textAlign: "right",
          }}
        >
          <span className="price-value">{String(door.price == null ? "0,0" : door.price.toFixed(2)).replace(".", ",")} €</span>
          <span className="price-label"> ohne MwSt.</span>
        </div>
        <div
          className="door-col-gross"
          style={{
            fontSize: "12px",
            color: "black",
            padding: "4px 2px",
            textAlign: "right",
          }}
          data-net={String(door.price == null ? "0,0" : door.price.toFixed(2)).replace(".", ",")}
        >
          <span className="price-value">{String(door.priceBrutto == null ? "0,0" : door.priceBrutto.toFixed(2)).replace(".", ",")} €</span>
          <span className="price-label"> inkl. MwSt. 19%</span>
        </div>
      </div>
    </div>
  );
};

export default DoorRow;
